import {
  AccountPayable,
  Installment,
  InstallmentRenegotiateFormValues,
  InstallmentSituation,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { Button, Form, Modal, ModalProps } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';

import RenegotiateInstallmentForm from './RenegotiateInstallmentForm';
import { MathRound } from '@/utils/functions/MathRound';

interface Props extends Omit<ModalProps, 'onOk'> {
  installmentList?: Installment[];
  accountPayable?: AccountPayable;
  isLoading?: boolean;
  onCallBackValues: (values?: InstallmentRenegotiateFormValues) => void;
  onCancel: () => void;
}

const RenegotiateInstallmentModal: React.FC<Props> = ({
  onCallBackValues,
  onCancel,
  open,
  installmentList,
  accountPayable,
  isLoading,
}) => {
  const [form] = Form.useForm<InstallmentRenegotiateFormValues>();

  useEffect(() => {
    if (installmentList) {
      form.setFieldsValue({
        valueTotal: installmentList
          .filter((item) => item.situation === InstallmentSituation.open)
          .reduce(
            (acc, curr) => (acc += MathRound(curr.installmentValue, 2)),
            0,
          ),
        fromThatDate: moment(),
      });
    }
  }, [installmentList, open]);

  const handleCancel = () => {
    form.resetFields();

    onCancel();
  };

  const handleOk = async () => {
    await onCallBackValues(form.getFieldsValue());

    form.resetFields();
  };

  return (
    <Modal
      width={860}
      open={open}
      onCancel={onCancel}
      title={'Renegociação'}
      footer={[
        <Button type="primary" ghost onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button type="primary" loading={isLoading} onClick={handleOk}>
          Renegociar
        </Button>,
      ]}
      destroyOnClose
    >
      <RenegotiateInstallmentForm form={form} accountPayable={accountPayable} />
    </Modal>
  );
};

export default RenegotiateInstallmentModal;
